import Vue from 'vue'

window.Vue = Vue

if (document.getElementById('cta')) {

    new Vue({
        el: '#cta',
        data: {
            error: false,
            isActive: false,
            date: null,
            storeKey: 'gibbstonCta',
            waitTime: 30000
        },
        computed: {
            classList() {
                return this.isActive ? 'active' : ''
            }
        },
        watch: {
            isActive: function() {
                const method = this.isActive ? 'add' : 'remove'
                document.querySelector('body').classList[method]('cta-active')
            }
        },
        mounted() {
            const store = window.localStorage.getItem(this.storeKey)

            this.date = new Date();
            this.date.setDate(this.date.getDate() + 7)

            if(store === null || (new Date().getTime() > parseInt(store))) {
                setTimeout(() => {
                    this.isActive = true
                }, this.waitTime)
            }
        },
        methods: {
            toggle() {
                if(this.isActive) {
                    this.isActive = false;
                    this.setToken()
                } else {
                    this.isActive = true;
                }
            },
            close(e) {
                if (e.target.getAttribute('id') === 'cta') {
                    this.isActive = false
                    this.setToken()
                }
            },
            linkClicked(e) {
                if (e.target.getAttribute('id') === 'cta-link') {
                    this.setToken()
                }
            },
            setToken() {
                window.localStorage.setItem(this.storeKey, this.date.getTime())
            }
        }
    })
}
